import { render, staticRenderFns } from "./dutyList.vue?vue&type=template&id=cadaa048"
import script from "./dutyList.vue?vue&type=script&lang=js"
export * from "./dutyList.vue?vue&type=script&lang=js"
import style0 from "./dutyList.vue?vue&type=style&index=0&id=cadaa048&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports